/**
 * TODO: refactor into Libs/graph-cards
 */

import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { SelectedValue, TachoGraphVersion } from '../SystemSettings/SystemSettingsUtils'

interface StyleProps {
  rotation: number
  isSelected: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  tachoPointer: {
    transition: 'transform 1s ease-in-out',
    transform: `rotate(${props.rotation}deg)`,
    transformOrigin: 'center calc(100% - 2.5px)',
    opacity: props.isSelected ? 1 : 0,
  },
}))
interface TachometerGraphProps {
  values: number[]
  min: number
  max: number
  setGraphValueColor: (idx: number, version: TachoGraphVersion) => [string, string]
  selectedValues: SelectedValue[]
}

interface TachoPointerProps {
  rotation: number
  index: number
  color: string
  isSelected: boolean
}

const TachoPointer: React.FC<TachoPointerProps> = ({ rotation, color, isSelected }) => {
  const { classes } = useStyles({ rotation, isSelected })

  return (
    <g className={classes.tachoPointer}>
      <path
        fill="#4A4A4A"
        d="M112.84 28.33c1.204 11.185 2.216 67.358 2.426 79.716.025 1.423-.958 2.572-2.344 2.8a2.996 2.996 0 01-1.252-.063l-.051-.014c-1.515-.404-2.585-1.785-2.542-3.335.414-15.191 2.544-90.429 3.763-79.105z"
      ></path>
      <path stroke={color} strokeWidth="2" d="M113 0L113 22"></path>
    </g>
  )
}

const TachometerGraph: React.FC<TachometerGraphProps> = ({ values, min, max, setGraphValueColor, selectedValues }) => {
  /**
   * Degree range: -90 to 90
   * @param value the current value to display
   * @param max the highest possible value
   * @param min the smalles possible value
   * @returns degree for the tacho pointer
   */
  const calcPointerDegree = (value: number, min: number, max: number): number => {
    const range = Math.abs(max) - min
    const resultingDegree = -90 + (180 * (value - min)) / range
    return resultingDegree
  }

  return (
    <svg fill="none" viewBox="0 0 224 114" overflow={'visible'}>
      <path
        fill="#C9EBC1"
        d="M224 113.001c0-29.97-11.8-58.712-32.804-79.903C170.192 11.906 141.704 0 112 0S53.808 11.906 32.804 33.098C11.8 54.289 0 83.03 0 113h21.648c0-24.177 9.52-47.363 26.463-64.459 16.945-17.096 39.926-26.7 63.889-26.7s46.944 9.604 63.889 26.7c16.944 17.096 26.463 40.282 26.463 64.459H224z"
      ></path>
      {values.map((value, idx) => {
        const [backgroundColor] = setGraphValueColor(idx, 'main')
        return (
          <TachoPointer
            key={idx}
            index={idx}
            rotation={calcPointerDegree(value, min, max)}
            color={backgroundColor}
            isSelected={selectedValues?.[idx]?.isSelected ?? false}
          />
        )
      })}
      <circle cx="112.08" cy="111.33" r="7" fill="#585A5E"></circle>
    </svg>
  )
}

export default TachometerGraph
